import gql from 'graphql-tag';

export const CHECK_MERIT_API_KEY = gql`
  query accounting($companyId: String!) {
    accounting {
      getMeritApiKey(companyId: $companyId)
    }
  }
`;
export const GET_COMPANY_DATA = gql`
  query getCompanyForAccountantCabinet($idCompany: String) {
    accounting {
      getCompanyForAccountantCabinet(id_company: $idCompany) {
        company {
          id
          marketId
        }
      }
    }
  }
`;

export const GET_MERIT_ITEMS_FROM_ENTY = gql`
  query getMeritItemsFromEnty($companyId: String!, $type: ItemTypeEnum) {
    invoicing {
      getMeritItemsFromEnty(companyId: $companyId, type: $type) {
        id
        companyId
        productType
        customerOrigin
        vatStatus
        meritItemCode
        combinationId
        meritTaxId
        name
        taxPct
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_MERIT_ITEMS_MERIT = gql`
  query getMeritItemsFromMeritWithTaxes($companyId: String!) {
    invoicing {
      getMeritItemsFromMeritWithTaxes(companyId: $companyId) {
        ItemId
        Code
        Name
        NameEN
        NameFI
        NameRU
        UnitofMeasureName
        Type0
        Type
        SalesPrice
        InventoryQty
        ReservedQty
        VatTaxName
        Usage0
        Usage
        SalesAccountCode
        PurchaseAccountCode
        InventoryAccountCode
        ItemCostAccountCode
        DiscountPct
        LastPurchasePrice
        ItemUnitCost
        InventoryCost
        ItemGroupName
        DefLoc_Name
        EANCode
        GTUCodes
        MeritTaxId
        MeritTaxName
        MeritTaxPct
      }
    }
  }
`;

export const GET_MERIT_ITEMS_LINKS = gql`
  query GetMeritItemsLinks($companyId: String!) {
    invoicing {
      getMeritItemsLinks(companyId: $companyId) {
        itemIdFromEnty
        itemCodeFromMerit
        meritTaxId
        meritTaxPct
      }
    }
  }
`;

export const GET_MERIT_ITEMS_FROM_MERIT_USAGE_TWO = gql`
  query getMeritItemsFromMeritUsageTwo($companyId: String!) {
    invoicing {
      getMeritItemsFromMeritUsageTwo(companyId: $companyId) {
        ItemId
        Code
        Name
        MeritTaxId
        MeritTaxName
        MeritTaxPct
      }
    }
  }
`;

export const GET_MERIT_ACCOUNTS = gql`
  query getMeritAccounts($companyId: String!) {
    accounting {
      getMeritAccounts(companyId: $companyId) {
        AccountID
        Code
        Name
        NameEN
        NameRU
        NoActive
        IsParent
      }
    }
  }
`;

export const GET_MERIT_TAXES = gql`
  query getMeritTaxes($companyId: String!) {
    invoicing {
      getMeritTaxes(companyId: $companyId) {
        Id
        Code
        Name
        TaxPct
      }
    }
  }
`;

export const GET_COUNTERPARTIES_FOR_MERIT_LINKS = gql`
  query getCounterpartiesForMeritLinks(
    $companyId: String!
    $search: String
    $excludeSystemCounterparties: Boolean
  ) {
    invoicing {
      getCounterpartiesForMeritLinks(
        companyId: $companyId
        search: $search
        excludeSystemCounterparties: $excludeSystemCounterparties
      ) {
        clientId
        taxNumber
        companyNumber
        meritCustomerId
        meritItemId
        meritTaxId
        name
        addresses {
          address
          city
          zip
          country
        }
      }
    }
  }
`;

/** Categories with Merit link fields for Merit settings (banking_category_items). */
export const GET_COMPANY_CATEGORIES_FOR_MERIT = gql`
  query GetCompanyCategories($companyId: String) {
    banking {
      getCompanyCategories(companyId: $companyId) {
        title
        type
        value {
          id
          title
          value
          groupId
          colour
          meritItemId
          meritTaxId
        }
      }
    }
  }
`;
